import { observable as p, attr as m } from "@microsoft/fast-element";
import { inputStyles as d } from "./input.styles.js";
import { inputTemplate as c } from "./input.template.js";
import { FASTTextField as h } from "@matrix42/fast-foundation";
import { InputMixin as f } from "../common/mixins/input-mixin.js";
import { applyMixins as x } from "../common/apply-mixins.js";
var C = Object.defineProperty, o = (s, r, a, u) => {
  for (var t = void 0, e = s.length - 1, l; e >= 0; e--)
    (l = s[e]) && (t = l(r, a, t) || t);
  return t && C(r, a, t), t;
};
const n = class n extends h {
  minChanged() {
    this.$fastController.isConnected && (this.control.min = this.min);
  }
  maxChanged() {
    this.$fastController.isConnected && (this.control.max = this.max);
  }
  connectedCallback() {
    super.connectedCallback(), this.postConnectedCallback(), this.control.min = this.min, this.control.max = this.max;
  }
  validate() {
    super.validate(), this.postValidate();
  }
};
n.definition = {
  name: "input",
  template: () => c,
  styles: d,
  shadowOptions: {
    delegatesFocus: !0
  }
};
let i = n;
o([
  p
], i.prototype, "slottedHints");
o([
  m
], i.prototype, "min");
o([
  m
], i.prototype, "max");
x(i, f);
export {
  i as Input
};
